// ============================================================================= //
//  Dependencies
// ============================================================================= //
import Lenis from '@studio-freight/lenis';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin( ScrollTrigger );

// ============================================================================= //
//  Smooth scroll
// ============================================================================= //

// Define a variable to store Lenis smooth scrolling object
let lenis;

// Function to initialize Lenis for smooth scrolling
const initSmoothScrolling = () => {

	// Instantiate the Lenis object with specified properties
	lenis = new Lenis({
		duration: 2,
		lerp: 0.1, // Lower values create a smoother scroll effect
		smoothWheel: true // Enables smooth scrolling for mouse wheel events
	});

	// Update ScrollTrigger each time the user scrolls
	lenis.on('scroll', () => ScrollTrigger.update());

	// Define a function to run at each animation frame
	const scrollFn = (time) => {
		lenis.raf(time); // Run Lenis' requestAnimationFrame method
		requestAnimationFrame(scrollFn); // Recursively call scrollFn on each frame
	};

	// Start the animation frame loop
	requestAnimationFrame(scrollFn);
};

initSmoothScrolling();


// ============================================================================= //
//  Smooth scroll to anchor links
// ============================================================================= //
const anchor = document.querySelectorAll('a[href^="#"]');

if ( anchor.length ) {
	anchor.forEach( (link) => {

		link.addEventListener('click', function (e) {
			e.preventDefault();
			const target = document.querySelector( this.getAttribute('href') );
			lenis.scrollTo( target.getBoundingClientRect().top );  lenis.scrollTo( target.getBoundingClientRect().top + window.scrollY - 50 );
		});
	});
}
